import React, { useState, useRef } from "react";
import ReactDOM from "react-dom";
import "./Tooltip.css";

const Tooltip = ({ text, children, position = "right", delay = 100 }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [coords, setCoords] = useState({ top: 0, left: 0 });
    const triggerRef = useRef(null);
    const timeoutRef = useRef(null);

    React.useEffect(() => {
        if (isVisible) {
            window.addEventListener("scroll", hideTooltip, { passive: true });
            window.addEventListener("resize", hideTooltip);
        }
        return () => {
            window.removeEventListener("scroll", hideTooltip);
            window.removeEventListener("resize", hideTooltip);
        };
    }, [isVisible]);

    const updatePosition = () => {
        if (triggerRef.current) {
            let rect = triggerRef.current.getBoundingClientRect();

            // If display: contents, the rect will be empty. Use children's rect instead.
            if (rect.width === 0 && rect.height === 0) {
                const firstChild = triggerRef.current.firstElementChild;
                if (firstChild) {
                    rect = firstChild.getBoundingClientRect();
                }
            }

            let top, left;

            if (position === "right") {
                top = rect.top + rect.height / 2;
                left = rect.right + 12;
            } else if (position === "left") {
                top = rect.top + rect.height / 2;
                left = rect.left - 12;
            } else if (position === "top") {
                top = rect.top - 12;
                left = rect.left + rect.width / 2;
            } else {
                top = rect.bottom + 12;
                left = rect.left + rect.width / 2;
            }

            setCoords({
                top: Math.round(top),
                left: Math.round(left)
            });
        }
    };

    const showTooltip = () => {
        updatePosition();
        timeoutRef.current = setTimeout(() => {
            setIsVisible(true);
        }, delay);
    };

    const hideTooltip = () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        setIsVisible(false);
    };

    return (
        <>
            <div
                ref={triggerRef}
                className="elevva-tooltip-trigger"
                onMouseEnter={showTooltip}
                onMouseLeave={hideTooltip}
            >
                {children}
            </div>
            {isVisible && text && ReactDOM.createPortal(
                <div
                    className={`elevva-tooltip-box ${position}`}
                    style={{
                        position: 'fixed',
                        top: `${coords.top}px`,
                        left: `${coords.left}px`,
                        transform: position === 'right' || position === 'left' ? 'translateY(-50%)' :
                            position === 'top' ? 'translate(-50%, -100%)' : 'translateX(-50%)'
                    }}
                >
                    <div className="elevva-tooltip-content">
                        {text}
                    </div>
                    <div className="elevva-tooltip-arrow"></div>
                </div>,
                document.body
            )}
        </>
    );
};

export default Tooltip;
